import {
  VACATION_BOOKING_STATUS,
  VACATION_ENTRY_STATUS,
  VACATION_ERROR_CODE,
  VACATION_SEASON,
  VACATION_TYPE,
  VACATION_WARNING_CODE
} from './vacation-api.constants';

export const VACATION_BOOKING_DATE_UNIT = 'days';
export const VACATION_BOOKING_YEAR_UNIT = 'years';

export const VACATION_BOOKING_PANEL_CONFIG = {
  DATE_FORMAT: 'YYYY-MM-DD',
  DESCRIPTION_MAX_LENGTH: 1000,
  EMPTY_TEXT: '',
  FIRST_PAGE: 0,
  MAXIMUM_ADVANCE_YEARS: 1,
  MINIMUM_LEAD_DAYS: 1,
  PAGE_SIZE: 20,
  PAGE_STEP: 1
};

export const VACATION_BOOKING_PANEL_KEY = {
  ACTION_ERROR: 'VACATION_BOOKING_ACTION_ERROR',
  BALANCE_LOAD_ERROR: 'VACATION_BALANCE_LOAD_ERROR',
  BOOKING_CANCELLED: 'VACATION_BOOKING_CANCELLED',
  BOOKING_CONFIRMED: 'VACATION_BOOKING_CONFIRMED',
  BOOKING_CREATED: 'VACATION_BOOKING_CREATED',
  ENTRIES_LOAD_ERROR: 'VACATION_ENTRIES_LOAD_ERROR',
  FORM_ERROR: 'VACATION_BOOKING_FORM_ERROR'
};

export const VACATION_ENTRY_STATUS_TRANSLATION: {[status: string]: string} = {
  [VACATION_BOOKING_STATUS.RESERVED]: 'VACATION_STATUS_RESERVED',
  [VACATION_BOOKING_STATUS.CONFIRMING]: 'VACATION_STATUS_CONFIRMING',
  [VACATION_BOOKING_STATUS.CONFIRMED]: 'VACATION_STATUS_CONFIRMED',
  [VACATION_BOOKING_STATUS.MATERIALIZED]: 'VACATION_STATUS_MATERIALIZED',
  [VACATION_BOOKING_STATUS.CANCELLED]: 'VACATION_STATUS_CANCELLED',
  [VACATION_BOOKING_STATUS.EXPIRED]: 'VACATION_STATUS_EXPIRED',
  [VACATION_ENTRY_STATUS.COORDINATION]: 'VACATION_STATUS_COORDINATION',
  [VACATION_ENTRY_STATUS.APPROVED]: 'VACATION_STATUS_APPROVED',
  [VACATION_ENTRY_STATUS.COMPLETED]: 'VACATION_STATUS_COMPLETED',
  [VACATION_ENTRY_STATUS.REJECTED]: 'VACATION_STATUS_REJECTED',
  [VACATION_ENTRY_STATUS.UNKNOWN]: 'VACATION_STATUS_UNKNOWN'
};

export const VACATION_ENTRY_STATUS_CLASS: {[status: string]: string} = {
  [VACATION_BOOKING_STATUS.RESERVED]: 'vacation-entry__status--reserved',
  [VACATION_BOOKING_STATUS.CONFIRMING]: 'vacation-entry__status--pending',
  [VACATION_BOOKING_STATUS.CONFIRMED]: 'vacation-entry__status--approved',
  [VACATION_BOOKING_STATUS.MATERIALIZED]: 'vacation-entry__status--materialized',
  [VACATION_BOOKING_STATUS.CANCELLED]: 'vacation-entry__status--negative',
  [VACATION_BOOKING_STATUS.EXPIRED]: 'vacation-entry__status--neutral',
  [VACATION_ENTRY_STATUS.COORDINATION]: 'vacation-entry__status--pending',
  [VACATION_ENTRY_STATUS.APPROVED]: 'vacation-entry__status--approved',
  [VACATION_ENTRY_STATUS.COMPLETED]: 'vacation-entry__status--completed',
  [VACATION_ENTRY_STATUS.REJECTED]: 'vacation-entry__status--negative',
  [VACATION_ENTRY_STATUS.UNKNOWN]: 'vacation-entry__status--neutral'
};

export const VACATION_ENTRY_STATUS_HINT_TRANSLATION: {[status: string]: string} = {
  [VACATION_BOOKING_STATUS.RESERVED]: 'VACATION_STATUS_HINT_RESERVED',
  [VACATION_BOOKING_STATUS.CONFIRMING]: 'VACATION_STATUS_HINT_CONFIRMING',
  [VACATION_BOOKING_STATUS.CONFIRMED]: 'VACATION_STATUS_HINT_CONFIRMED',
  [VACATION_BOOKING_STATUS.MATERIALIZED]: 'VACATION_STATUS_HINT_MATERIALIZED',
  [VACATION_BOOKING_STATUS.CANCELLED]: 'VACATION_STATUS_HINT_CANCELLED',
  [VACATION_BOOKING_STATUS.EXPIRED]: 'VACATION_STATUS_HINT_EXPIRED',
  [VACATION_ENTRY_STATUS.COORDINATION]: 'VACATION_STATUS_COORDINATION',
  [VACATION_ENTRY_STATUS.APPROVED]: 'VACATION_STATUS_APPROVED',
  [VACATION_ENTRY_STATUS.COMPLETED]: 'VACATION_STATUS_COMPLETED',
  [VACATION_ENTRY_STATUS.REJECTED]: 'VACATION_STATUS_REJECTED',
  [VACATION_ENTRY_STATUS.UNKNOWN]: 'VACATION_STATUS_UNKNOWN'
};

export const VACATION_SEASON_TRANSLATION: {[season: string]: string} = {
  [VACATION_SEASON.SPRING]: 'VACATION_SEASON_SPRING',
  [VACATION_SEASON.SUMMER]: 'VACATION_SEASON_SUMMER',
  [VACATION_SEASON.AUTUMN]: 'VACATION_SEASON_AUTUMN',
  [VACATION_SEASON.WINTER]: 'VACATION_SEASON_WINTER'
};

export const VACATION_TYPE_TRANSLATION: {[type: string]: string} = {
  [VACATION_TYPE.PAID_LEAVE]: 'PAID_LEAVE',
  [VACATION_TYPE.UNPAID_LEAVE]: 'UNPAID_LEAVE',
  [VACATION_TYPE.SICK_LEAVE]: 'SICK_LEAVE',
  [VACATION_TYPE.BUSINESS_TRIP]: 'BUSINESS_TRIP'
};

export const VACATION_ERROR_TRANSLATION: {[code: string]: string} = {
  [VACATION_ERROR_CODE.APPROVAL_ROUTE_UNVERIFIED]: 'VACATION_ERROR_APPROVAL_ROUTE_UNVERIFIED',
  [VACATION_ERROR_CODE.APPROVAL_ROUTE_INVALID]: 'VACATION_ERROR_APPROVAL_ROUTE_INVALID',
  [VACATION_ERROR_CODE.APPROVAL_RECIPIENT_UNAVAILABLE]: 'VACATION_ERROR_APPROVAL_RECIPIENT_UNAVAILABLE',
  [VACATION_ERROR_CODE.APPROVAL_SELF_UNRESOLVED]: 'VACATION_ERROR_APPROVAL_SELF_UNRESOLVED',
  [VACATION_ERROR_CODE.BALANCE_UNAVAILABLE]: 'VACATION_ERROR_BALANCE_UNAVAILABLE',
  [VACATION_ERROR_CODE.DATE_INVALID]: 'VACATION_ERROR_DATE_INVALID',
  [VACATION_ERROR_CODE.OVERLAP]: 'VACATION_ERROR_OVERLAP',
  [VACATION_ERROR_CODE.BALANCE_EXCEEDED]: 'VACATION_ERROR_BALANCE_EXCEEDED',
  [VACATION_ERROR_CODE.SEASON_ALREADY_USED]: 'VACATION_ERROR_SEASON_ALREADY_USED',
  [VACATION_ERROR_CODE.CAPACITY_EXCEEDED]: 'VACATION_ERROR_CAPACITY_EXCEEDED',
  [VACATION_ERROR_CODE.CONFIRMATION_NOT_OPEN]: 'VACATION_ERROR_CONFIRMATION_NOT_OPEN',
  [VACATION_ERROR_CODE.CONFIRMATION_EXPIRED]: 'VACATION_ERROR_CONFIRMATION_EXPIRED',
  [VACATION_ERROR_CODE.BOOKING_NOT_FOUND]: 'VACATION_ERROR_BOOKING_NOT_FOUND',
  [VACATION_ERROR_CODE.BOOKING_REQUIRED]: 'VACATION_ERROR_BOOKING_REQUIRED',
  [VACATION_ERROR_CODE.DEPARTMENT_CHANGED]: 'VACATION_ERROR_DEPARTMENT_CHANGED',
  [VACATION_ERROR_CODE.REQUEST_INVALID]: 'VACATION_ERROR_REQUEST_INVALID',
  [VACATION_ERROR_CODE.ACCESS_DENIED]: 'VACATION_ERROR_ACCESS_DENIED',
  [VACATION_ERROR_CODE.CONCURRENT_UPDATE]: 'VACATION_ERROR_CONCURRENT_UPDATE',
  [VACATION_ERROR_CODE.PLANFIX_UNAVAILABLE]: 'VACATION_ERROR_PLANFIX_UNAVAILABLE'
};

export const VACATION_WARNING_TRANSLATION: {[code: string]: string} = {
  [VACATION_WARNING_CODE.FIRST_WORK_YEAR]: 'VACATION_WARNING_FIRST_WORK_YEAR',
  [VACATION_WARNING_CODE.SHORT_PART]: 'VACATION_WARNING_SHORT_PART',
  [VACATION_WARNING_CODE.OVERLAP]: 'VACATION_WARNING_OVERLAP',
  [VACATION_WARNING_CODE.BALANCE_EXCEEDED]: 'VACATION_WARNING_BALANCE_EXCEEDED',
  [VACATION_WARNING_CODE.SEASON_ALREADY_USED]:
    'VACATION_WARNING_SEASON_ALREADY_USED',
  [VACATION_WARNING_CODE.CAPACITY_EXCEEDED]: 'VACATION_WARNING_CAPACITY_EXCEEDED'
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/vacation/vacation-booking-panel.constants.ts